import { Collapsable } from 'components/common/Collapsable'
import { Icon } from 'components/common/Icon'
import { useIsMobile } from '../../hooks'

type Props = {
  iconName: string
  title: string
  shortDescription: React.ReactNode
  longDescription?: React.ReactNode
  hasCollapsable?: boolean
  className?: string
  id?: string
}

export const FeatureCard = ({
  iconName,
  title,
  shortDescription,
  longDescription,
  hasCollapsable = true,
  className,
  id = '',
}: Props) => {
  const isMobile = useIsMobile()

  return (
    <div
      id={id}
      className={`flex flex-col items-start rounded-lg border border-solid border-cool-300 bg-cool-50 px-6 py-5 md:p-10 ${className}`}
    >
      <div className='w-full'>
        <div className='-mx-1.5 -my-1.5 mb-3 flex items-center md:mb-0 md:flex-col md:items-start'>
          <div className='mx-1.5 my-1.5 h-6 w-6 text-primary-default md:h-8 md:w-8'>
            <Icon
              name={iconName}
              filled
              size={24}
              className='card-icon md:hidden'
            />
            <Icon
              name={iconName}
              filled
              size={32}
              className='card-icon hidden md:block'
            />
          </div>

          <p className='mx-1.5 my-1.5 font-display font-medium text-cool-900 md:mb-2 md:hidden'>
            {title}
          </p>
          <h5 className='mx-1.5 my-1.5  hidden font-medium text-cool-900 md:mb-2 md:block'>
            {title}
          </h5>
        </div>
        <div className={'mt-1.5  text-sm text-cool-600 md:text-base'}>
          {shortDescription}
        </div>
      </div>
      {hasCollapsable && (
        <Collapsable
          titleClassName='!justify-start !items-center'
          className='w-full'
          type='featureCard'
          iconSize={isMobile ? 20 : 24}
          iconClassName='mb-[2px] !text-secondary-default'
          title={
            <p className='text-sm text-secondary-default md:text-base'>
              Learn more
            </p>
          }
          openTitle={
            <p className='text-sm text-secondary-default md:text-base'>
              Show less
            </p>
          }
        >
          <div className='mb-4 mt-2 !w-full'>{longDescription}</div>
        </Collapsable>
      )}
    </div>
  )
}
